import { useTextTranslation } from "../../utils/useTextTranslation";
import { toTrackId } from "../../analytics/trackIds";
import React, { useEffect, useRef, useState } from "react";

import TvFavoriteIcon from "../../assets/icons/svg/TvFavoriteIcon";
import { getBroadcastCopy } from "../../statics/broadcastCopy";
import localizationStrings from "../../statics/localization";
import TvLockIcon from "../../assets/icons/svg/TvLockIcon";

const ChannelListItem = ({
  item,
  selectedChannel,
  onSelectChannel,
  useFavoriteName,
  onClickLock,
  onClickFav,
  uKey,
  showList,
  index,
  trackIdPrefix
}) => {
  const translateText = useTextTranslation();
  const copy = getBroadcastCopy();
  const [isFav, setIsFav] = useState(false);
  const [isLocked, setIsLocked] = useState(false);

  const itemRef = useRef(null);

  useEffect(() => {
    const isFavourite = item?.interactions?.find(
      (element) => element === "CHANNEL_FAV"
    );

    const isLock = item?.interactions?.find(
      (element) => element === "CHANNEL_LOCK"
    );

    setIsFav(!!isFavourite);
    setIsLocked(!!isLock);
  }, [item?.interactions]);

  useEffect(() => {
    if (item && selectedChannel && selectedChannel?.id === item?.id) {
      if (document.getElementById(`vertical-channel-list-${uKey}`)) {
        document
          .getElementById(`vertical-channel-list-${uKey}`)
          .scrollTo(
            0,
            itemRef.current.offsetTop - itemRef.current.offsetHeight - 120
          );
      }
    }
  }, [item, selectedChannel, showList]);

  return (
    <div
      className={`channel-list-item ${
        selectedChannel?.id === item?.id ? "selected" : ""
      }`}
      ref={itemRef}
    >
      <div className="icons">
        <button
          type="button"
          aria-label={`${localizationStrings.lock || "Lock"} · ${item?.name}`}
          aria-pressed={isLocked}
          className={`icon ${isLocked ? "fill-yellow" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            onClickLock(item);
          }}
        >
          <TvLockIcon isLocked={isLocked} />
        </button>
        <button
          type="button"
          aria-label={`${copy.favorites} · ${item?.name}`}
          aria-pressed={isFav}
          className={`icon ${isFav ? "fill-red" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            onClickFav(item);
          }}
        >
          <TvFavoriteIcon isFavorite={isFav} />
        </button>
      </div>
      <button
        type="button"
        data-track-id={trackIdPrefix ? toTrackId(trackIdPrefix, index + 1) : undefined}
        className="channel-select"
        onClick={() => onSelectChannel(item)}
        aria-label={`${copy.watch} · ${item?.name}`}
        aria-pressed={selectedChannel?.id === item?.id}
      >
        <div className="channel-logo">
          <img className="logo" alt={item?.name} src={item?.logo} loading="lazy" decoding="async" />
        </div>
        <div className="channel-info">
          <div className="channel-name" title={item?.name}>
            {useFavoriteName ? item?.favoritename : item?.name}
          </div>
          <div
            className="program-name"
            title={translateText(item?.currentProgram?.title || item?.programName)}
          >
            {translateText(item?.currentProgram?.title || item?.programName)}
          </div>
        </div>
      </button>
    </div>
  );
};

export default ChannelListItem;
